import { uniqBy } from 'lodash-es'

const getDefaultState = () => {
  return {
    showHelp: {
      'bldr-datasets': false,
      'bldr-collections': false,
      'bldr-collections-table': null,
    },
    studyOptions: [],
    // legacy managed assay registration
    selectedStudies: [],
    sampleNamesAndBarcodes: '',
    successData: null,
  }
}

const state = { ...getDefaultState() }

const getters = {
  studyOptions: (state) => {
    return uniqBy(
      state.studyOptions.map((o) => ({
        ...o,
        _displayName: o.name.value.name,
        _flatId: o.id.value,
        choice_label: o.choice_label.value,
      })),
      '_flatId',
    )
  },
}

const mutations = {
  RESET(state) {
    Object.assign(state, getDefaultState())
  },
  RESET_STUDY_OPTIONS(state) {
    state.studyOptions = []
    state.selectedStudies = []
  },
  ADD_STUDY_OPTIONS(state, options) {
    state.studyOptions = uniqBy([...options, ...state.studyOptions], 'id.value')
  },
  SELECT_STUDIES(state, studies) {
    state.selectedStudies = uniqBy(studies, 'id')
  },
  SET_SAMPLENAMES_AND_BARCODES(state, sampleNamesAndBarcode) {
    state.sampleNamesAndBarcodes = sampleNamesAndBarcode
  },
  SET_SHOW_HELP(state, { key, value }) {
    state.showHelp[key] = value
  },
  TOGGLE_HELP(state, key) {
    state.showHelp[key] = !state.showHelp[key]
  },
  SET_SUCCESS_DATA(state, data) {
    state.successData = data
  },
}

const dataloader = {
  namespaced: true,
  state,
  getters,
  mutations,
}

export default dataloader
